// extracted by mini-css-extract-plugin
module.exports = {"sort":"LR","selected":"MR","disabled":"NR"};